module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  computed:

    footerSpacerHeight: ->
      @.$store.state.window.footerSpacerHeight || 0

    style: ->
      { height: "#{@footerSpacerHeight}px" }


// WEBPACK FOOTER //
// ./assets/js/frontend/components/footer_bottom_spacer/index.coffee